import React, {Component} from 'react';
import {gpn} from "../GPN"
import req from "../req";
import config from "../config";
import Collapsible from "react-collapsible";
import ModalLoading from "../sections/ModalLoading";
import Icon from "../sections/MUI/Icon";

class Payments extends Component {

    state = {
        payments: null
    }

    componentDidMount() {
        this.props.setTitle("پرداخت ها");
        req.getRequest(`${config.api}/user/payments`)
            .then(r => {
                this.setState({payments: r});
            })
            .catch(err => {
                config.handleError(err);
            });
    }

    statusColor(status = "") {
        let color = "#FF3D00";
        if (status.includes("پرداخت موفق")) {
            color = "#139f01";
        } else if (status.includes("پرداخت ناموفق") || status.includes("پرداخت نشد")) {
            color = "#c00e0e"
        }
        return color;
    }

    handleOpen(index, open = false) {
        let {payments} = this.state;
        payments[index].open = open;
        this.setState({payments});
    }

    render() {
        let {payments} = this.state;

        return (
            <div className="payments">

                <ModalLoading loading={!payments}/>

                <div className="list">
                    {
                        payments ?
                            payments.length > 0 ?
                                payments?.map((o, i) =>
                                    <article key={"payment" + i}>
                                        <Collapsible
                                            onTriggerOpening={() => this.handleOpen(i, true)}
                                            onTriggerClosing={() => this.handleOpen(i, false)}
                                            trigger={
                                                <div className="collapse-header">
                                                    <div className="header-info"
                                                         style={{color: this.statusColor(o.status)}}>
                                                        <div className="row justify-content-between">
                                                            <div className="col-auto">
                                                                <div
                                                                    className="created-at">{o.code ? o.code !== "" ? o.code : o.createdAt.split(" ")[0] : o.createdAt.split(" ")[0]}{o.isService ?
                                                                    <span
                                                                        className="is-service" style={{
                                                                        color: "#545454",
                                                                        fontSize: "9pt",
                                                                        marginRight: 10
                                                                    }}>(خدمات)</span> : null}</div>
                                                            </div>
                                                            <div className="col" style={{textAlign: "center"}}>
                                                                <div className="ref"
                                                                     style={{textAlign: "center"}}>{o.ref}</div>
                                                            </div>
                                                            <div className="col-auto">
                                                                <Icon i={o.open ? "chevron-up" : "chevron-down"}
                                                                      className="arrow-icon"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            transitionTime={50}>
                                            <div className="body">

                                                <div className="info">
                                                    <p><span>وضعیت:</span><span
                                                        style={{color: this.statusColor(o.status)}}>{o.status}</span>
                                                    </p>
                                                    {o.ref !== "" ?
                                                        <p><span>کد پیگیری:</span><span>{o.ref}</span></p> :
                                                        null
                                                    }
                                                    <p>
                                                        <span>مبلغ:</span><span>{config.priceFormatter(o.amount)}&nbsp;تومان</span>
                                                    </p>
                                                </div>


                                            </div>
                                        </Collapsible>


                                    </article>)
                                : <div className="no-order-item">تاکنون پرداختی انجام نداده اید!</div>
                            : null
                    }
                </div>
            </div>
        );
    }
}

export default gpn(Payments);